import React from 'react';
import { Settings, User, Bell, CreditCard } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';

const BusinessSettings = () => {
  return (
    <div className="space-y-6">
      <Card>
        <CardHeader>
          <CardTitle>Business Settings - Coming Soon</CardTitle>
        </CardHeader>
        <CardContent className="p-8 text-center">
          <Settings className="w-16 h-16 text-gray-400 mx-auto mb-4" />
          <h3 className="font-semibold text-lg mb-2">Business Configuration</h3>
          <p className="text-gray-600">
            Configure your business profile, payment methods, notification preferences, and more.
          </p>
        </CardContent>
      </Card>
    </div>
  );
};

export default BusinessSettings;